;(function (angular, _) {
  'use strict'

  class SelectBpuComponent {
    $q
    ngModel
    entity
    disabled
    bpuManager
    bpuList = []

    constructor (
      // Angular
      $q,
      // Libs
      // Managers
      BpuManager
      // Services
      // Const
      // Resolved
    ) {
      this.bpuManager = BpuManager
      this.$q = $q
    }

    get bpu () {
      return this.ngModel.$viewValue
    }

    set bpu (bpu) {
      this.ngModel.$setViewValue(bpu)
    }

    $onChanges (changes) {
      if (changes.entity && changes.entity.previousValue) {
        this.unSelectBpu()
      }
      if (changes.entity && changes.entity.currentValue) {
        this.searchBpus()
      }
    }

    unSelectBpu () {
      this.bpu = null
    }

    /**
     * Search bpu
     * @param search
     * @return {Promise<Bpu[]>}
     */
    searchBpus (search = '') {
      let promise
      if (!this.entity) {
        promise = this.$q.resolve([])
      } else {
        const clientId = _.get(this.entity, '_id', this.entity)
        const query = this.bpuManager.query({
          populate: JSON.stringify([
            {
              path: 'client'
            }
          ]),
          conditions: {
            $and: [
              { client: clientId }
            ]
          }
        })
        if (search.trim().length) {
          const searchRegex = {
            $regex: search.trim(),
            $options: 'i'
          }
          query.opts.conditions.$and = [...query.opts.conditions.$and, {
            $or: [
              { label: searchRegex },
              { number: searchRegex }
            ]
          }]
        }
        promise = this.bpuManager.get(query)
      }

      return promise.then(({ data }) => {
        this.bpuList = data
        return data
      })
    }
  }

  SelectBpuComponent.$inject = [
    // Angular
    '$q',
    // Libs
    // Managers
    'BpuManager'
    // Services
    // Const
    // Resolved
  ]
  angular.module('kilo.common.components')
    .component('selectBpu', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        disabled: '<',
        entity: '<'
      },
      controller: SelectBpuComponent,
      templateUrl: '/app/common/components/select-bpu/select-bpu.template.html'
    })
})(window.angular, window._)
